import type { FSA } from 'types/redux';
import { sendPreviewMessage } from 'omega-rtc/actions/newTridentExtra';

export const SEND_JOURNEY_TEST_NOTIFICATION = 'SEND_JOURNEY_TEST_NOTIFICATION';
export const JOURNEY_TEST_NOTIFICATION_FAILURE_MESSAGE = 'The test notification request failed. Verify delivery before retrying.';
export type JourneyTestNotificationRequest = {
  recipientID: string;
  recipientType: 'passenger' | 'driver' | 'foodmax';
  template: {
    id: string;
    enableLangDetection: true;
    extraParams: Record<string, unknown>;
  };
};

// Preserve the preview endpoint, wire payload and auth middleware. Only isolate
// request state and propagate a sanitized rejection to the sending component.
export const sendJourneyTestNotification = (data: JourneyTestNotificationRequest): FSA => {
  const preview = sendPreviewMessage(data);
  return {
    ...preview,
    type: SEND_JOURNEY_TEST_NOTIFICATION,
    meta: {
      ...preview.meta,
      errorHandler(error, next, action, defaultErrorHandler) {
        const status = error && error.response && error.response.status;
        const sanitizedError = Object.assign(new Error(JOURNEY_TEST_NOTIFICATION_FAILURE_MESSAGE), {
          response: {
            status: typeof status === 'number' ? status : undefined,
            statusText: JOURNEY_TEST_NOTIFICATION_FAILURE_MESSAGE,
            data: { message: JOURNEY_TEST_NOTIFICATION_FAILURE_MESSAGE },
          },
        });
        // The shared handler displays a snackbar as well as recording failure.
        // Never forward provider text, headers, or error details into either path.
        defaultErrorHandler(sanitizedError, next, action);
        throw sanitizedError;
      },
    },
  };
};
